if (!customElements.get('curio-craft-film')) {
  customElements.define('curio-craft-film', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.curio-film__player');
      this.querySelectorAll('[data-film-open]').forEach(button => button.addEventListener('click', () => {
        const id = this.dataset.videoId;
        if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) return;
        this.opener = button;
        const frame = document.createElement('iframe');
        frame.title = this.querySelector('h2').textContent;
        frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&playsinline=1&rel=0`;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.player.replaceChildren(frame);
        this.dialog.showModal();
        this.querySelector('[data-film-close]').focus();
      }));
      this.querySelector('[data-film-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => {
        this.player.replaceChildren();
        this.opener?.focus();
      });
    }
    disconnectedCallback() {
      this.player?.replaceChildren();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
